// extracted by mini-css-extract-plugin
export default {"companyRegister":"companyRegister__BIKZv","infoiHolder":"infoiHolder__MTbcd","radioboxLabelText":"radioboxLabelText__hD0qs"};